import { AnimatePresence } from 'framer-motion';
import { useRef } from 'react';
import animations from '../../helpers/animations';
import { usePaymentModalStore } from '../../store/payment/paymentModalStore';
import CardForm from './pieces/CardForm';
import InstallmentsForm from './pieces/InstallmentsForm';
import {
    BackgroundModal,
    CloseModalButton,
    ModalContent,
    ModalTitle,
    ModalWrapper,
} from './styles';

export function ModalPaymentCard() {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const paymentModal = usePaymentModalStore();
    
    if (paymentModal.method !== 'card') return;

    function handleCloseModal() {
        paymentModal.update({
            isVisible: false,
            isntallmentsVisibility: false,
        });
    }

    return (
        <AnimatePresence>
            {paymentModal.isVisible && paymentModal.method === 'card' && (
                <BackgroundModal
                    ref={modalRef}
                    onClick={handleCloseModal}
                    {...animations.fadeInOut(0.1)}
                >
                    <ModalWrapper onClick={e => e.stopPropagation()}>
                        {!paymentModal.isntallmentsVisibility && (
                            <>
                                <ModalTitle>
                                    <p>Cartão</p>
                                </ModalTitle>
                                <CloseModalButton onClick={handleCloseModal} />
                                <ModalContent>
                                    <CardForm />
                                </ModalContent>
                            </>
                        )}
                        {paymentModal.isntallmentsVisibility && (
                            <InstallmentsForm
                                handleCloseModal={handleCloseModal}
                            />
                        )}
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>
    );
}
